import React from "react";
import { WizTableForm } from '@/containers/common'

//配置项
const componentName = "dimStudentReport";
const organization = { allowTreeSelect: true , ...WizTableForm.Config.organization(this)}
const user = WizTableForm.Config.person()

const _getTypeValue = (type, key) => {
  const values = {
    0: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    1: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    2: {
      0: '草稿',
      1: '已发布',
      2: '已取消',
      3: '已结束'
    },
    3: {
      1: '草稿',
      2: '预告中',
      3: '直播中',
      4: '已结束'
    },
    4: {
      1: '草稿',
      2: '已发布',
      3: '已结束'
    },
    5: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    }
  }
  return values[type][key] || ''
}

function columns(self) {
  let {type} = self.state
  let bizStateDict = [
    { code: 0, codeName: '草稿' },
    { code: 1, codeName: '已发布' },
    { code: 2, codeName: '已关闭' }]
  if (type == 2) {
    bizStateDict = [
      { code: 0, codeName: '草稿' },
      { code: 1, codeName: '已发布' },
      { code: 2, codeName: '已取消' },
      { code: 3, codeName: '已结束' }
    ]
  } else if (type == 3) {
    bizStateDict = [
      { code: 1, codeName: '草稿' },
      { code: 2, codeName: '预告中' },
      { code: 3, codeName: '直播中' },
      { code: 4, codeName: '已结束' }
    ]
  } else if (type == 4) {
    bizStateDict = [
      { code: 1, codeName: '草稿' },
      { code: 2, codeName: '已发布' },
      { code: 3, codeName: '已关闭' },
    ]
  } 
  return [
    {
      title: "业务类型",
      name: 'types',
      searchItem: {
        type: 'select',
        mode: 'multiple',
        formatInit: () => [0,1,2,3,4,5],
        onChange: (from, value) => {
          self.setState({type: value})
        },
        rules: [
          {
            required: true,
            message: '业务类型'
          }
        ]
      },
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 2, codeName: '作业' },
        { code: 3, codeName: '直播' },
        { code: 4, codeName: '路径' },
        { code: 5, codeName: '班级' }
      ]
    },
    {
      title: "组织名称",
      name: "orgIds",
      searchItem: {
        ...organization,
        diy: WizTableForm,
        onChangeRowMap: (e) => {},
      },
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "学员账号",
      name: 'userName',
      tableItem: {}
    },
    {
      title: "学员姓名",
      name: 'fullName',
      tableItem: {},
    },
    {
      title: "账号状态",
      name: 'accountState',
      tableItem: {},
      dict: [
        { code: 1, codeName: '激活' },
        { code: 0, codeName: '禁用' },
      ]
    },
    {
      title: "上级组织",
      name: 'leadName',
      tableItem: {},
    },
    {
      title: "组织名称",
      name: 'orgName',
      tableItem: {},
    },
    {
      title: "组织编码",
      name: 'orgCode',
      tableItem: {},
    },
    {
      title: "省份",
      name: 'province',
      tableItem: {},
    },
    {
      title: "岗位",
      name: 'positionName',
      tableItem: {},
    },
    {
      title: "任职状态",
      name: 'jobState',
      tableItem: {},
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' }
      ]
    },
    {
      title: "业务状态",
      name: 'bizState',
      tableItem: {
        render: (text, record) => {
          let {type} = record
          return _getTypeValue(type, text)
        }
      },
      // dict: bizStateDict
    },
    {
      title: "业务名称",
      name: 'bizName',
      tableItem: {},
    },
    {
      title: "业务类型",
      name: 'type',
      tableItem: {},
      dict: [
        { code: 0, codeName: '课程' },
        { code: 1, codeName: '考试' },
        { code: 2, codeName: '作业' },
        { code: 3, codeName: '直播' },
        { code: 4, codeName: '路径' },
        { code: 5, codeName: '班级' }
      ]
    },
    {
      title: '关联业务名称',
      name: 'bizRelationName',
      tableItem: {},
    },
    {
      title: "是否主岗",
      name: 'userIdentityType',
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 2, codeName: '否' },
        { code: 1, codeName: '是' }
      ]
    },
    {
      title: "分数",
      name: 'score',
      tableItem: {},
    },
    {
      title: "结果",
      name: 'pass',
      tableItem: {},
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
      ]
    },
    {
      title: "开始时间",
      name: 'startDate',
      tableItem: {},
    },
    {
      title: "结束时间",
      name: 'endDate',
      tableItem: {},
    },
  ];
}

function templateConfig(self) {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(self),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: [],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
